import { localeService } from './locale.service';

export const updateUserLocale = (locale: string) =>
  localeService.updateLocale(locale);
